export const scoreSummary = {
  score: 91,
  change: "+4%",
};

export const aiSummary = {
  lastUpdated: "Nov 18, 2025 10:12 UTC",
  executive:
    "Ledger integrity remains strong with 100% block finalization across critical nodes. Two validator nodes show delayed anchoring events, increasing audit latency by 6 minutes.",
  confidence: "89% (High)",
  methodology:
    "Consensus health checks with anomaly detection over block propagation and anchor timing.",
};

export const recommendedActions = [
  {
    priority: "Critical Priority",
    priorityTone: "priorityCritical",
    borderColor: "#dc2626",
    title: "Remediate Delayed Anchoring on Validator-03",
    description:
      "Validator-03 is lagging by 12 blocks during peak periods. Investigate network latency and resync validator to restore anchoring SLAs.",
    cve: "Consensus Alert",
  },
  {
    priority: "High Priority",
    priorityTone: "priorityHigh",
    borderColor: "#f59e0b",
    title: "Rotate Keys for Audit Relay Node",
    description:
      "Audit relay key is nearing expiration in 5 days. Rotate keys to prevent failed signature verification on new blocks.",
    cve: "Key Lifecycle",
  },
  {
    priority: "Medium Priority",
    priorityTone: "priorityMedium",
    borderColor: "#38bdf8",
    title: "Enable Compression for Block Replication",
    description:
      "Replication bandwidth spikes above threshold on month-end cycles. Compression will reduce propagation delay.",
    cve: "Performance",
  },
  {
    priority: "Low Priority",
    priorityTone: "priorityLow",
    borderColor: "#0ea5e9",
    title: "Audit Validator Log Retention",
    description:
      "Extend retention to 180 days to support longer audit windows and regulatory inquiries.",
    cve: "Policy",
  },
];

export const riskTrend = [
  { month: "Jan", score: 94 },
  { month: "Feb", score: 93 },
  { month: "Mar", score: 92 },
  { month: "Apr", score: 92 },
  { month: "May", score: 91 },
  { month: "Jun", score: 90 },
  { month: "Jul", score: 91 },
  { month: "Aug", score: 89 },
  { month: "Sep", score: 90 },
  { month: "Oct", score: 88 },
  { month: "Nov", score: 91 },
  { month: "Dec", score: 91 },
];

export const riskFactors = [
  {
    asset: "#8432166",
    category: "Validator",
    score: 92,
    cve: "Anchoring OK",
    lastScanned: "12m ago",
    status: "Protected",
  },
  {
    asset: "#843210",
    category: "Validator",
    score: 78,
    cve: "Delayed Anchoring",
    lastScanned: "28m ago",
    status: "Protected",
  },
  {
    asset: "#843215",
    category: "Relay",
    score: 84,
    cve: "Key Rotation Due",
    lastScanned: "1h ago",
    status: "Protected",
  },
  {
    asset: "#843212",
    category: "Archive",
    score: 88,
    cve: "Replication Lag",
    lastScanned: "2h ago",
    status: "Protected",
  },
  {
    asset: "#843213",
    category: "Gateway",
    score: 90,
    cve: "Integrity Verified",
    lastScanned: "3h ago",
    status: "Protected",
  },
];
